import { render, staticRenderFns } from "./addSetmeal.vue?vue&type=template&id=147d8710&scoped=true&"
import script from "./addSetmeal.vue?vue&type=script&lang=js&"
export * from "./addSetmeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d8710",
  null
  
)

export default component.exports